import { useTranslation } from 'react-i18next'
import { ReportChart } from '@/components/relatorios/ReportChart'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv, formatPercent } from '@/components/relatorios/reportUtils'
import { useCampaignSalesReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'
import { useCurrency } from '@/hooks/useCurrency'

export default function VendasCampanhaReport() {
  const { t } = useTranslation('reports')
  const { formatCurrency } = useCurrency()
  const [range, setRange] = useReportDateRange()
  const report = useCampaignSalesReport(range)
  const leads = report.data.reduce((sum, row) => sum + row.leads, 0)
  const sales = report.data.reduce((sum, row) => sum + row.sales, 0)
  const revenue = report.data.reduce((sum, row) => sum + row.revenue, 0)

  return (
    <ReportShell
      title={t('campaign.title')}
      description={t('campaign.description')}
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={leads === 0}
      onRetry={report.refetch}
      onExport={() => exportCsv('vendas-campanha', report.data, [
        { label: t('fields.campaign'), value: (row) => row.campaign },
        { label: t('fields.leads'), value: (row) => row.leads },
        { label: t('fields.sales'), value: (row) => row.sales },
        { label: t('fields.revenue'), value: (row) => row.revenue.toFixed(2).replace('.', ',') },
        { label: t('fields.conversionPct'), value: (row) => row.conversion.toFixed(1).replace('.', ',') },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label={t('campaign.kpiLeads')} value={leads} />
        <ReportKpiCard label={t('fields.sales')} value={sales} />
        <ReportKpiCard label={t('fields.revenue')} value={formatCurrency(revenue)} />
        <ReportKpiCard label={t('fields.conversion')} value={formatPercent(leads ? (sales / leads) * 100 : 0)} />
      </div>
      <ReportChart
        type="bar"
        data={report.data.map((row) => ({ ...row }))}
        xKey="campaign"
        series={[
          { key: 'leads', label: t('fields.leads'), color: 'var(--chart-1)' },
          { key: 'sales', label: t('fields.sales'), color: 'var(--chart-2)' },
        ]}
      />
      <ReportTable
        rows={report.data}
        rowKey={(row) => row.campaignId}
        columns={[
          { key: 'campaign', label: t('fields.campaign'), render: (row) => row.campaign },
          { key: 'leads', label: t('fields.leads'), align: 'right', render: (row) => row.leads },
          { key: 'sales', label: t('fields.sales'), align: 'right', render: (row) => row.sales },
          { key: 'revenue', label: t('fields.revenue'), align: 'right', render: (row) => formatCurrency(row.revenue) },
          { key: 'conversion', label: t('fields.conversion'), align: 'right', render: (row) => formatPercent(row.conversion) },
        ]}
      />
    </ReportShell>
  )
}
